import React from "react";

function InformationIcon() {
    return (
        <svg
            viewBox="0 0 24 24"
            width="20"
            height="20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g fill="none" fillRule="evenodd">
                <circle
                    fill="currentColor"
                    opacity="0.3"
                    cx="12"
                    cy="12"
                    r="10"
                />
                <rect
                    fill="currentColor"
                    x="11"
                    y="10"
                    width="2"
                    height="7"
                    rx="1"
                />
                <rect
                    fill="currentColor"
                    x="11"
                    y="7"
                    width="2"
                    height="2"
                    rx="1"
                />
            </g>
        </svg>
    );
}

export default InformationIcon;
